/**
 * Raw CSS injected into the print popup window.
 *
 * A print popup is a brand-new `document`, so it can't see the app's
 * bundled/webpack CSS files (HostelStudentIdCard1.css,
 * HostelStudentIdCardVertical.css). We keep a copy of the *print-relevant*
 * rules here so the popup renders correctly no matter which card design
 * was selected.
 *
 * NOTE: if you change the visual design in either .css file, mirror the
 * relevant rule here too (colors, sizes, layout) so printed cards keep
 * matching the on-screen preview.
 */

export const HOSTEL_CARD_HORIZONTAL_PRINT_CSS = `
.hostel-id-card-horizontal-1 {
  width: 95mm;
  height: 65mm;
  border: 2pt solid rgba(255, 0, 0, 0.688);
  border-radius: 10px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}

.hostel-id-card-horizontal-1 .institute-details {
  font-size: 8px;
  font-weight: bold;
  color: black;
  white-space: nowrap;
}

.hostel-id-card-horizontal-1 .institute-details h6 {
  font-weight: 900;
  color: rgba(255, 0, 0);
  font-size: 22px;
  margin: 0;
}

.hostel-id-card-horizontal-1 div {
  font-size: 10px;
  color: black;
  font-weight: bold;
}

.hostel-id-card-horizontal-1 .card_name {
  font-weight: 500;
  background-color: rgba(255, 0, 0, 0.662);
  padding: 1px 3px;
  color: white;
  border-radius: 2px;
}

.hostel-id-card-horizontal-1 .address {
  font-size: 8px;
  color: black;
  font-weight: bold;
}

.hostel-id-card-horizontal-1 .col-1 {
  width: 2%;
}

.hostel-id-card-horizontal-1 .border {
  border: 1pt solid rgba(255, 0, 0, 0.688);
}

.hostel-id-card-horizontal-1 .border-top {
  border-top: 1pt solid rgba(255, 0, 0, 0.688);
}

.hostel-id-card-horizontal-1 .profile-img {
  width: 80px;
  height: 100px;
  object-fit: cover;
}

.hostel-id-card-horizontal-1::before {
  content: "";
  position: absolute;
  inset: 0;
  background-repeat: no-repeat;
  background-position: 30% center;
  background-size: 150px;
  opacity: 0.4;
  z-index: -1;
}

.hostel-id-card-horizontal-1 .admission-date {
  position: absolute;
  right: 5px;
  top: 85%;
  transform: rotate(90deg) translateY(-50%);
  transform-origin: right top;
  font-size: 8px;
  font-weight: bold;
  white-space: nowrap;
}

.hostel-id-card-horizontal-1 .signature {
  position: absolute;
  right: 12px;
  bottom: 1px;
  font-size: 8px;
  white-space: nowrap;
}

.hostel-id-card-horizontal-1 .signature img {
  width: 80px;
}

.hostel-id-card-horizontal-1 .signature p {
  margin: 0 12px 6px 0;
}
`;

export const HOSTEL_CARD_VERTICAL_PRINT_CSS = `
.hostel-id-card-vertical-1 {
  width: 54mm;
  height: 86mm;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border: 1pt solid #1d4ed8;
  font-family: Arial, Helvetica, sans-serif;
}

.hostel-id-card-vertical-1 .v1-header {
  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);
  color: #fff;
  text-align: center;
  padding: 6px 4px 20px;
}

.hostel-id-card-vertical-1 .v1-header img.v1-logo {
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 4px;
}

.hostel-id-card-vertical-1 .v1-header h6 {
  font-size: 10px;
  font-weight: 900;
  margin: 2px 0 0;
  text-transform: uppercase;
  line-height: 1.1;
}

.hostel-id-card-vertical-1 .v1-header p {
  font-size: 6px;
  margin: 1px 0 0;
  opacity: 0.9;
}

.hostel-id-card-vertical-1 .v1-photo-wrap {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2pt solid #fff;
  overflow: hidden;
  margin: -18px auto 0;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.hostel-id-card-vertical-1 .v1-photo-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hostel-id-card-vertical-1 .v1-card-tag {
  text-align: center;
  font-size: 7px;
  font-weight: 700;
  color: #1d4ed8;
  letter-spacing: 0.5px;
  margin-top: 4px;
  text-transform: uppercase;
}

.hostel-id-card-vertical-1 .v1-name {
  text-align: center;
  font-size: 11px;
  font-weight: 900;
  color: #111827;
  margin: 2px 6px 0;
  line-height: 1.1;
}

.hostel-id-card-vertical-1 .v1-reg {
  text-align: center;
  font-size: 7px;
  font-weight: 700;
  color: #6b7280;
  margin: 1px 0 4px;
}

.hostel-id-card-vertical-1 .v1-details {
  padding: 0 8px;
  font-size: 7px;
  color: #111827;
}

.hostel-id-card-vertical-1 .v1-details .v1-row {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  border-bottom: 0.5pt dashed #e5e7eb;
  padding: 1.5px 0;
}

.hostel-id-card-vertical-1 .v1-details .v1-label {
  color: #6b7280;
  font-weight: 700;
  white-space: nowrap;
}

.hostel-id-card-vertical-1 .v1-details .v1-value {
  font-weight: 700;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hostel-id-card-vertical-1 .v1-address {
  font-size: 6px;
  color: #374151;
  padding: 3px 8px 0;
  text-align: center;
  font-weight: 600;
  line-height: 1.2;
}

.hostel-id-card-vertical-1 .v1-footer {
  position: absolute;
  bottom: 3px;
  left: 8px;
  right: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 6px;
}

.hostel-id-card-vertical-1 .v1-footer .v1-sign img {
  width: 40px;
  display: block;
}

.hostel-id-card-vertical-1 .v1-footer .v1-sign p,
.hostel-id-card-vertical-1 .v1-footer .v1-joined p {
  margin: 1px 0 0;
  font-weight: 700;
  color: #6b7280;
}
`;

export const HOSTEL_CARD_MODERN_PRINT_CSS = `
.hostel-id-card-modern-1 {
  width: 95mm;
  height: 60mm;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  background: #fafafa;
  border: 1pt solid #e2e2e2;
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
}

.hostel-id-card-modern-1 .m1-band {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #0f172a;
  color: #fff;
  padding: 6px 10px;
}

.hostel-id-card-modern-1 .m1-band .m1-logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
  background: #fff;
  border-radius: 4px;
  padding: 1px;
}

.hostel-id-card-modern-1 .m1-band-text {
  line-height: 1.1;
}

.hostel-id-card-modern-1 .m1-institute-name {
  margin: 0;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.hostel-id-card-modern-1 .m1-institute-sub {
  margin: 1px 0 0;
  font-size: 6px;
  color: #cbd5e1;
}

.hostel-id-card-modern-1 .m1-body {
  display: flex;
  gap: 8px;
  padding: 8px 10px 0;
  flex: 1;
}

.hostel-id-card-modern-1 .m1-photo {
  width: 46px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1pt solid #d4d4d4;
}

.hostel-id-card-modern-1 .m1-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hostel-id-card-modern-1 .m1-info {
  flex: 1;
  min-width: 0;
}

.hostel-id-card-modern-1 .m1-tag {
  display: inline-block;
  font-size: 6px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #f59e0b;
  border: 0.75pt solid #f59e0b;
  border-radius: 3px;
  padding: 1px 4px;
}

.hostel-id-card-modern-1 .m1-name {
  margin: 3px 0 3px;
  font-size: 11px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hostel-id-card-modern-1 .m1-grid {
  display: grid;
  grid-template-columns: 32px 1fr;
  row-gap: 1.5px;
  column-gap: 4px;
  font-size: 7px;
}

.hostel-id-card-modern-1 .m1-label {
  color: #94a3b8;
  font-weight: 700;
}

.hostel-id-card-modern-1 .m1-value {
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hostel-id-card-modern-1 .m1-address {
  font-size: 6px;
  color: #475569;
  font-weight: 600;
  padding: 3px 10px 0;
}

.hostel-id-card-modern-1 .m1-strip {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  background: #f1f5f9;
  border-top: 1pt dashed #cbd5e1;
  padding: 3px 10px;
  font-size: 6px;
  color: #475569;
  font-weight: 700;
}

.hostel-id-card-modern-1 .m1-strip .m1-id {
  font-family: "Courier New", Courier, monospace;
  letter-spacing: 1px;
  color: #0f172a;
  font-size: 8px;
}

.hostel-id-card-modern-1 .m1-strip .m1-sign {
  width: 30px;
  height: auto;
}
`;

export const buildPrintDocument = (bodyHtml) => `
  <html>
    <head>
      <title>Print ID Cards</title>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" />
      <style>
        @page { size: A4; margin: 10mm; }
        * { box-sizing: border-box; }
        body { margin: 0; font-family: Arial, Helvetica, sans-serif; }
        .print-sheet {
          display: flex;
          flex-wrap: wrap;
          gap: 4mm;
          align-content: flex-start;
        }
        .id-card-print-block {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        ${HOSTEL_CARD_HORIZONTAL_PRINT_CSS}
        ${HOSTEL_CARD_VERTICAL_PRINT_CSS}
        ${HOSTEL_CARD_MODERN_PRINT_CSS}
      </style>
    </head>
    <body>
      <div class="print-sheet">${bodyHtml}</div>
    </body>
  </html>
`;
